import { useLayoutEffect } from 'react';

// Paint <html>/<body> (the strip behind the iOS status bar) for the mounted
// page. Pages with white content at the very top pass `var(--bg-page)`.
export default function useRootBackground(color) {
  useLayoutEffect(() => {
    const html = document.documentElement;
    const { body } = document;
    const prevHtml = html.style.backgroundColor;
    const prevBody = body.style.backgroundColor;
    html.style.backgroundColor = color;
    body.style.backgroundColor = color;
    return () => {
      html.style.backgroundColor = prevHtml;
      body.style.backgroundColor = prevBody;
    };
  }, [color]);
}
